import { render } from "./WizardLandingPage.vue?vue&type=template&id=29332a81&scoped=true"
import script from "./WizardLandingPage.vue?vue&type=script&lang=js"
export * from "./WizardLandingPage.vue?vue&type=script&lang=js"

import "./WizardLandingPage.vue?vue&type=style&index=0&id=29332a81&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29332a81"

export default script